/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './fitbit-service.pb';
import { GRPC_FITBIT_SERVICE_CLIENT_SETTINGS } from './fitbit-service.pbconf';
/**
 * Service client implementation for api.fitbit.FitbitService
 */
@Injectable({ providedIn: 'any' })
export class FitbitServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /api.fitbit.FitbitService/StartLogin
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.StartLogInResponse>>
     */
    startLogin: (
      requestData: thisProto.StartLogInRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.StartLogInResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.fitbit.FitbitService/StartLogin',
        requestData,
        requestMetadata,
        requestClass: thisProto.StartLogInRequest,
        responseClass: thisProto.StartLogInResponse
      });
    },
    /**
     * Unary call: /api.fitbit.FitbitService/CompleteLogin
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.CompleteLogInResponse>>
     */
    completeLogin: (
      requestData: thisProto.CompleteLogInRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.CompleteLogInResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.fitbit.FitbitService/CompleteLogin',
        requestData,
        requestMetadata,
        requestClass: thisProto.CompleteLogInRequest,
        responseClass: thisProto.CompleteLogInResponse
      });
    },
    /**
     * Unary call: /api.fitbit.FitbitService/GetLoginStatus
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetLoginStatusResponse>>
     */
    getLoginStatus: (
      requestData: thisProto.GetLoginStatusRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetLoginStatusResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.fitbit.FitbitService/GetLoginStatus',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetLoginStatusRequest,
        responseClass: thisProto.GetLoginStatusResponse
      });
    },
    /**
     * Unary call: /api.fitbit.FitbitService/LogOut
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.LogOutResponse>>
     */
    logOut: (
      requestData: thisProto.LogOutRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.LogOutResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.fitbit.FitbitService/LogOut',
        requestData,
        requestMetadata,
        requestClass: thisProto.LogOutRequest,
        responseClass: thisProto.LogOutResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_FITBIT_SERVICE_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'api.fitbit.FitbitService',
      settings
    );
  }

  /**
   * Unary call @/api.fitbit.FitbitService/StartLogin
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.StartLogInResponse>
   */
  startLogin(
    requestData: thisProto.StartLogInRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.StartLogInResponse> {
    return this.$raw
      .startLogin(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.fitbit.FitbitService/CompleteLogin
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.CompleteLogInResponse>
   */
  completeLogin(
    requestData: thisProto.CompleteLogInRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.CompleteLogInResponse> {
    return this.$raw
      .completeLogin(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.fitbit.FitbitService/GetLoginStatus
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetLoginStatusResponse>
   */
  getLoginStatus(
    requestData: thisProto.GetLoginStatusRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetLoginStatusResponse> {
    return this.$raw
      .getLoginStatus(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.fitbit.FitbitService/LogOut
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.LogOutResponse>
   */
  logOut(
    requestData: thisProto.LogOutRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.LogOutResponse> {
    return this.$raw
      .logOut(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
